var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0656 20.1529C29.1172 25.7342 33.9622 27.5917 34.0157 27.6155C33.9747 27.7461 33.2417 30.2624 31.4634 32.861C29.9262 35.1077 28.3305 37.3462 25.8174 37.3931C23.348 37.4382 22.5539 35.9283 19.7303 35.9283C16.9076 35.9283 16.0256 37.3462 13.6877 37.4382C11.2617 37.5302 9.41421 35.0083 7.86423 32.7701C4.69716 28.1911 2.27674 19.8308 5.52663 14.1875C7.14104 11.385 10.0267 9.61061 13.1584 9.56489C15.5405 9.51947 17.7891 11.1674 19.2452 11.1674C20.7005 11.1674 23.4329 9.18548 26.3055 9.47642C27.5082 9.52659 30.8836 9.96211 33.0511 13.1351C32.8768 13.2435 29.0237 15.4867 29.0656 20.1529ZM24.4245 6.44741C25.7124 4.88852 26.5792 2.71777 26.3429 0.558594C24.4863 0.633109 22.2413 1.79567 20.9098 3.35397C19.7164 4.73355 18.6714 6.9423 18.9531 9.05872C21.0226 9.21903 23.1364 8.00719 24.4245 6.44741Z",
    fill: "#161616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/Apple.8f5bc80cc12fd2f2b856aaccebb6d900.svg";
export { ForwardRef as ReactComponent };